import { render, staticRenderFns } from "./videoExplain.vue?vue&type=template&id=1b31d3e9&scoped=true"
import script from "./videoExplain.vue?vue&type=script&lang=js"
export * from "./videoExplain.vue?vue&type=script&lang=js"
import style0 from "./videoExplain.vue?vue&type=style&index=0&id=1b31d3e9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b31d3e9",
  null
  
)

export default component.exports